import React, { useState } from 'react';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'

import logo from '../../static/img/logo.svg'
import icon_user from '../../static/img/icon-user.svg'
import icon_user_login from '../../static/img/icon-user_login.svg'
import burger from '../../static/img/burger-1.svg'
import burger2 from '../../static/img/burger-2.svg'
import logo2 from '../../static/img/logo-2.svg'
import pay_logos from '../../static/img/PAY_LOGOS.png'
import { Calc } from './calc';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsLogin, selectShowPopUpManager, selectUserEmail, setCalcPage, setShowPopUpManager } from '../home/homeSlice';
import { useNavigate } from 'react-router-dom';
import burger_2 from '../../static/img/burger-2.png'
import { MAIN_ROUTE } from '../../static/vars';
import { FormManager } from '../home/formManager';

export function MainCalc() {
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const [showMessengerSelecter, setShowMessengerSelecter] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    const userEmail = useSelector(selectUserEmail)
    const isLogin = useSelector(selectIsLogin)
    const showPopUpManager = useSelector(selectShowPopUpManager)

    const handleLogin = () => {
        if (isLogin) navigate(MAIN_ROUTE + '/personal', { replace: true })
        else navigate(MAIN_ROUTE + '/login', { replace: true })
    }

    return (
        <>
            <div className="App">
                {/* header */}
                <header class="header" id="header">
                    <div class="header-contant">
                        <div class="header-contant-logo">
                            <a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/"><img src={logo} alt="logo" /></a>
                        </div>
                        <div class="header-contant-user">
                            <div onClick={handleLogin} class="user"><img src={isLogin ? icon_user_login : icon_user} alt="logo" /></div>
                        </div>
                        <div  onClick={()=>setShowMenu(!showMenu)} class="header-contant-menu">
                            <img class="burger-1" src={burger} alt="logo" />
                        </div>
                    </div>
                    {showMenu &&
                        <div class="mobile-container">
                            <img   onClick={()=>setShowMenu(!showMenu)} class="burger-2" src={burger2} alt="logo" />
                            <div class="mobile-container-vnutr">
                                <ul class="main-menu txt_a_l">
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/" className="txt_nowrap">Страхование ипотеки</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/o-kompanii/">О компании</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/promo/">Акции</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/#policies">Как выбрать полис</a></li>
                                    <li class="main-menu-up"><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/#faq">Частые вопросы</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/news/">Новости</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/novostroiki/">Новостройки</a></li>
                                    <li><a href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/banks/">Банки</a></li>
                                </ul>
                            </div>
                        </div>
                    }
                </header>

                {/* calc */}
                <Calc />

                {/* footer */}
                <footer class="footer">
                    <div class="conteiner">
                        <div class="footer-contant">
                            <div class="footer-contant-up">
                                <div class="footer-contant-up-col footer-contant-up-col-1">
                                    <h2 class="h2 h2-footer">Остались вопросы?</h2>
                                    <div class="footer-contacts">
                                        <div class="footer-contacts-row">
                                            <a class="footer-phone-link footer-phone-link-1" href="tel:84991304230">8 ( 499 )
                                                130 42
                                                30</a>
                                            <p class="footer-phone-text">Москва</p>
                                        </div>
                                        <div class="footer-contacts-row">
                                            <a class="footer-phone-link" href="tel:88047004230">8 ( 804 ) 700 42 30</a>
                                            <p class="footer-phone-text">Россия</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer-contant-up-col footer-contant-up-col-2">
                                    <p class="footer-button-text footer-button-text-1">Наши опытные менеджеры готовы помочь вам
                                        оформить страховку под
                                        ваш запрос.</p>
                                    {/* <a class="button button-footer" data-da=".footer-contant-up-col-1,768,3"
                                        href="javascript:PopUpShow()">Оформить с
                                        менеджером</a> */}
                                    <div onClick={() => dispatch(setShowPopUpManager(true))} class="button button-footer">
                                            Оформить с менеджером
                                        </div>
                                </div>
                            </div>
                            <div class="footer-contant-down">
                                <div class="footer-contant-down-col-1 t_a_l">
                                    <a href="index.html"><img src={logo2} alt="logo" /></a>
                                    <p class="footer-logo-text">Минимальная цена на обязательное <br />ипотечное страхование</p>
                                    <div class="footer-blok-link">
                                        <div class="footer-blok-link-left">
                                            <p class="footer-link-text footer-button-text">Услуги</p>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/">Страхование ипотеки</a>
                                            <a class="footer-link footer-logo-text" href="user.html">Личный кабинет</a>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/novostroiki/">Новостройки</a>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/banks/">Банки</a>
                                        </div>
                                        <div class="footer-blok-link-right">
                                            <p class="footer-link-text footer-button-text">Информация</p>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/o-kompanii/">О компании</a>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/news/">Новости</a>
                                            <a class="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/kontakty/">Контакты</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer-contant-down-col-2">
                                    <a class="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Обработка персональных
                                        данных</a>
                                    <a class="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Политика
                                        конфеденциальности</a>
                                    <a class="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Правовая информация</a>
                                    <p class="footer-description">Сайт использует файлы «cookie» с целью персонализации сервисов
                                        и повышения удобства
                                        пользования веб-сайтом.Если вы не хотите использовать файлы «cookie», изменитенастройки
                                        браузера.</p>
                                    <img src={pay_logos} alt="banks" />
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

                {/* popup-1 */}
                {showPopUpManager &&
                    <FormManager/>
                }

                {/* popup-2 */}
                {false && <div class="b-popup" id="popup2">
                    <div class="b-popup-vnutr"></div>
                    <div class="b-popup-content b-popup-content-2">
                        <p class="popup-title popup-title-2">Авторизация</p>
                        <form class="form-popup">
                            <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-1">
                                <label for="select-1">E-mail</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="E-mail" type="email" placeholder="|"
                                    required />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-2">
                                <label for="select-1">Пароль</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="E-mail" type="email"
                                    placeholder="*********" required />
                            </div>
                            <button class="button button-1 button-popup-1">Войти</button>
                            <a href="#!" class="popup2-link">Не помню пароль</a>
                        </form>
                        <a class="popup-close" href="javascript:PopUpHide2()"><img src="img/close.svg" alt="close" /></a>
                    </div>
                </div>}

                {/* popup-3 */}
                {false && <div class="b-popup" id="popup3">
                    <div class="b-popup-vnutr"></div>
                    <div class="b-popup-content b-popup-content-2">
                        <p class="popup-title popup-title-2">Контактная информация</p>
                        <p class="popup-text">Что бы зафиксировать цену и получить другие предложения, оставьте контактную
                            информацию: Наш менеджер свяжется в ближайшее время!</p>
                        <form class="form-popup">
                            <div class="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-3">
                                <label for="select-1">Имя</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                    required />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-2 one-ryad-popup-user one-ryad-popup-user-4">
                                <label for="select-1">Телефон</label>
                                <input class="pole-popup pole-popup-user pole-popup-2" name="Телефон" type="tel" placeholder="+7"
                                    pattern="^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$" required />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-5">
                                <div class="form-group">
                                    <div class="dropdown">
                                        <label for="select-1">Удобный способ связи</label>
                                        <button
                                            class="dropdown__button dropdown__button-popup dropdown__button-popup-user">Телеграм</button>
                                        <ul class="dropdown__list">
                                            <li class="dropdown__list-item" data-value="Телеграм">Телеграм</li>
                                            <li class="dropdown__list-item" data-value="Ватсап">Ватсап</li>
                                            <li class="dropdown__list-item" data-value="Апартаменты">Вайбер</li>
                                            <li class="dropdown__list-item" data-value="Апартаменты">ВКонтакте</li>
                                        </ul>
                                        <input type="text" name="select-category" value="" class="dropdown__input-hidden" />
                                    </div>
                                </div>
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-4  one-ryad-popup-user one-ryad-popup-user-6">
                                <label for="select-1">Адрес объекта</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                    required />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-5  one-ryad-popup-user one-ryad-popup-user-7">
                                <label for="select-1">Дата начала действия полиса</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text"
                                    placeholder="ДД.ММ.ГГГГ" required />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-6  one-ryad-popup-user one-ryad-popup-user-8">
                                <label for="select-1">Комментарий</label>
                                <input class="pole-popup pole-popup-user pole-popup-1" name="Имя" type="text" placeholder=""
                                    required />
                            </div>
                            <button class="button button-1 button-popup-1">Оставить заявку</button>
                        </form>
                        <a class="popup-close" href="javascript:PopUpHide3()"><img src="img/close.svg" alt="close" /></a>
                    </div>
                </div>}
            </div>
        </>
    );
}



